<div class="container" *rxBusy="busy">
  <div class="container__title">
    {{ payload.title }}
  </div>
  <div class="container__body">
    <!-- <rx-signature #signature (onEndEvent)="onDrawingComplete($event)"></rx-signature> -->
    {{ payload.subTitle }}
  </div>
  <div class="container__buttons">
    <rx-button class="flex" (click)="onBrowseClientLibraryClicked($event)">Client Library</rx-button>
    <rx-button
      class="flex"
      rxUpload
      accept="image/*"
      multiple="multiple"
      [style.color]="''"
      (uploadedFiles)="onUploadedFiles($event)"
    >
      Upload Images
    </rx-button>
    <!-- <rx-button class="blue footer__button" (click)="onAttachClicked($event)">Attach</rx-button> -->
    <rx-button class="flex fwb" (click)="onCancelClicked($event)">Cancel</rx-button>
  </div>
</div>
